import { Link } from 'react-router';
import Icon from '@/components/elements/Icon/Icon';
import Chevron from '@/assets/icons/chevron.svg';

const COMPANY_NAV_ITEMS = [
    { label: 'Overview', href: '/company/overview' },
    { label: 'Founders', href: '/company/founders' },
    { label: 'Advisory Board', href: '/company/advisors' },
    { label: 'Press', href: '/company/press-pr-media-kit' },
] as const;

const USE_CASES_NAV_ITEMS = [
    { label: 'PEOs', href: '/use-cases/peos-payroll-employment-organizations' },
    { label: 'General Agents', href: '/use-cases/general-agents' },
    { label: 'TPAs', href: '/use-cases/tpas-third-party-administrators' },
    { label: 'FMOs', href: '/use-cases/fmos' },
    { label: 'Brokers', href: '/use-cases/brokers' },
] as const;

export type CompanySubnavSection = 'company' | 'use-cases';

type CompanySubnavProps = {
    currentLabel: string;
    section?: CompanySubnavSection;
};

const SECTION_COPY: Record<
    CompanySubnavSection,
    { parentLabel: string; items: readonly { label: string; href: string }[] }
> = {
    company: {
        parentLabel: 'Company',
        items: COMPANY_NAV_ITEMS,
    },
    'use-cases': {
        parentLabel: 'Use Cases',
        items: USE_CASES_NAV_ITEMS,
    },
};

export function CompanySubnav({
    currentLabel,
    section = 'company',
}: CompanySubnavProps) {
    const { parentLabel, items } = SECTION_COPY[section];

    return (
        <section className="mt-10 w-full">
            <div className="mx-auto flex w-full flex-col gap-3 px-5 py-4 md:flex-row md:items-center md:justify-between md:px-10 lg:px-[79px]">
                <div className="flex items-center gap-1">
                    <span className="text-lg text-gray-450">{parentLabel}</span>
                    <span className="inline-flex px-2 align-middle text-gray-400">
                        <Icon
                            src={Chevron}
                            className="size-4 -rotate-90 text-gray-400"
                        />
                    </span>
                    <span className="text-lg text-gray-900">{currentLabel}</span>
                </div>

                <div className="flex flex-wrap gap-2">
                    {items.map((item) => {
                        const isActive = item.label === currentLabel;
                        return (
                            <Link
                                key={item.href}
                                to={item.href}
                                className={`rounded-lg px-2 py-1 text-base lg:px-3 lg:py-2 ${
                                    isActive
                                        ? 'bg-brand-100 text-brand-700'
                                        : 'text-brand-700 hover:bg-brand-100'
                                }`}
                            >
                                {item.label}
                            </Link>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
